if (!customElements.get("clerk-cart-upsell")) {
  customElements.define(
    "clerk-cart-upsell",
    class ClerkCartUpsell extends HTMLElement {
      constructor() {
        super();

        this.select = this.querySelector("select");

        if (this.select) {
          this.select.addEventListener("change", this.onSelectChange.bind(this));
        }

        this.prices = Array.from(this.querySelectorAll("[data-upsell-price]"));

        this.selectVariant = this.querySelector("[data-select-variant]");
        this.overlay = this.querySelector(".clerk-slider-image__overlay");
        if (this.selectVariant && this.overlay) {
          this.selectVariant.addEventListener("click", () => {
            this.overlay.classList.toggle("clerk-slider-image__overlay--active");
          });
        }

        this.submitVariants = this.querySelectorAll("[data-submit-variant]");
        this.submit = this.querySelector("[data-submit]");

        if (this.submit) {
          this.submitVariants.forEach((submitVariant) => {
            submitVariant.addEventListener("click", () => {
              this.select.value = submitVariant.value;
              this.select.dispatchEvent(new Event("change"));

              // on mobile sizes, it should remove the overlay, use window.matchMedia to check for mobile
              if (window.matchMedia("(max-width: 990px)").matches) {
                this.submit.click();
              }

              this.submit.hidden = false;
              const firstSpan = this.submit.querySelector("span");
              if (firstSpan) {
                if (window.matchMedia("(max-width: 990px)").matches) {
                  firstSpan.textContent = window.theme.strings.addToCartShort;
                } else {
                  firstSpan.textContent = window.theme.strings.addToCart;
                }
              }
              this.selectVariant.hidden = true;

              submitVariant.classList.add("active");
              this.submitVariants.forEach((variant) => {
                if (variant !== submitVariant) {
                  variant.classList.remove("active");
                }
              });
            });
          });
        }
      }

      onSelectChange(evt) {
        const selected = evt.target.value;
        this.prices.forEach((price) => {
          price.hidden = true;
        });

        this.prices.find((price) => price.dataset.upsellPrice === selected).hidden = false;
      }
    }
  );
}

const getCartData = async () => {
  const response = await fetch("/cart.js");
  const data = await response.json();
  return {
    items: data.items,
    productTypes: data.items.map((item) => item.product_type),
    productHandles: data.items.map((item) => item.handle),
  };
};

const getProductData = async (handles) => {
  const productDataPromises = handles.map((handle) =>
    fetch(`${window.Shopify.routes.root}products/${handle}.js`).then((response) => response.json())
  );
  return Promise.all(productDataPromises);
};

const getUniqueProductTypes = (productTypes) => {
  return [...new Set(productTypes)];
};

const getUniqueGenderTags = (products) => {
  const genderTags = ["Men", "Women", "Boys", "Girls"];
  const foundTags = new Set();
  products.forEach((product) => {
    product.tags.forEach((tag) => {
      if (genderTags.includes(tag)) {
        foundTags.add(tag);
      }
    });
  });
  return Array.from(foundTags);
};

const clerkCartUpsell = window.theme.clerk.cartDrawer.enabled;

const initCartUpsell = async () => {
  const desktopUpsellDrawer = document.querySelector("[data-clerk-drawer-desktop]");
  const mobileUpsellDrawer = document.querySelector("[data-clerk-drawer-mobile]");

  const endpoint = window.theme.clerk.cartDrawer.endpoint;
  const limit = window.theme.clerk.cartDrawer.limit;
  const label = window.theme.clerk.cartDrawer.label;

  const apiKey = window.theme.strings.clerkApiKey;

  const products = [];
  let productTypes = [];
  let genderTags = [];
  if (endpoint !== "recently_bought") {
    const cartData = await getCartData();
    const productData = await getProductData(cartData.productHandles);

    cartData.items.forEach((item) => {
      products.push(item.product_id.toString());
    });
    productTypes = getUniqueProductTypes(cartData.productTypes);
    genderTags = getUniqueGenderTags(productData);
  }

  if (endpoint !== "recently_bought" && products.length === 0) {
    desktopUpsellDrawer.hidden = true;
    return;
  }

  const productTypeFilter = productTypes.length > 0 ? productTypes.map((type) => `type contains "${type}"`).join(" or ") : "";
  const genderTagFilter = genderTags.length > 0 ? genderTags.map((tag) => `tags contains "${tag}"`).join(" or ") : "";
  const stockFilter = "stock > 0";

  let combinedFilter = stockFilter;
  if (productTypeFilter) {
    combinedFilter += ` and (${productTypeFilter})`;
  }
  if (genderTagFilter) {
    combinedFilter += ` and (${genderTagFilter})`;
  }

  await Clerk(
    "call",
    `recommendations/${endpoint}`,
    {
      key: apiKey,
      limit: limit,
      labels: [`${label}`],
      attributes: ["id", "handle", "name", "price_min", "price_max", "stock", "product_type", "tags"],
      filter: combinedFilter,
      ...(products.length > 0 && { products }),
    },
    async function (response) {
      desktopUpsellDrawer.hidden = false;

      const productHandles = response.product_data.map((product) => product.handle);
      const productFetches = productHandles.map(async (handle) => {
        const productResponseResult = await fetch(`/products/${handle}?view=upsell`);

        if (productResponseResult.ok) {
          return productResponseResult;
        }
        return null;
      });

      const productResponses = await Promise.all(
        (
          await Promise.all(productFetches)
        )
          .map((response) => {
            if (response) {
              return response.text();
            }
            return null;
          })
          .filter((response) => response)
      );

      const productListWrappers = document.querySelectorAll("[data-clerk-upsell-product-list]");

      productResponses.forEach((productResponse) => {
        const parser = new DOMParser();
        const productDocument = parser.parseFromString(productResponse, "text/html");
        const productElement = productDocument.querySelector("[data-upsell-item]");

        const divWrapper = document.createElement("div");
        divWrapper.appendChild(productElement);
        divWrapper.classList.add("clerk-slider-item");

        productListWrappers.forEach((productListWrapper) => {
          productListWrapper.appendChild(divWrapper.cloneNode(true));
        });
      });

      const mobileDrawer = document.querySelector("[data-clerk-drawer-mobile]");
      const mobileDrawerWrapper = document.querySelector("[data-clerk-upsell-mobile-wrapper]");

      while (mobileDrawerWrapper.firstChild) {
        mobileDrawerWrapper.removeChild(mobileDrawerWrapper.firstChild);
      }
      mobileDrawerWrapper.appendChild(mobileDrawer.cloneNode(true));

      mobileDrawerWrapper.querySelector("[data-clerk-drawer-mobile]").hidden = false;

      const mobileListWrapper = document.querySelector("[data-mobile-slider]");
      const prev = document.querySelector("[data-prev]");
      const next = document.querySelector("[data-next]");

      prev.addEventListener("click", () => {
        mobileListWrapper.scrollTo({
          left: mobileListWrapper.scrollLeft - 200,
          behavior: "smooth",
        });
      });

      next.addEventListener("click", () => {
        mobileListWrapper.scrollTo({
          left: mobileListWrapper.scrollLeft + 200,
          behavior: "smooth",
        });
      });

      document.addEventListener("cart-drawer-rendered", () => {
        const newMobileDrawerWrapper = document.querySelector("[data-clerk-upsell-mobile-wrapper]");

        while (newMobileDrawerWrapper.firstChild) {
          newMobileDrawerWrapper.removeChild(newMobileDrawerWrapper.firstChild);
        }
        newMobileDrawerWrapper.appendChild(mobileDrawer.cloneNode(true));

        newMobileDrawerWrapper.querySelector("[data-clerk-drawer-mobile]").hidden = false;
        const clerkSliderImages = document.querySelectorAll(".clerk-slider-image a");
        clerkSliderImages.forEach((image) => {
          image.removeAttribute("data-clerk-click-tracking-added");
        });

        const newMobileListWrapper = document.querySelector("[data-mobile-slider]");
        const newPrev = document.querySelector("[data-prev]");
        const newNext = document.querySelector("[data-next]");

        newPrev.addEventListener("click", () => {
          newMobileListWrapper.scrollTo({
            left: newMobileListWrapper.scrollLeft - 200,
            behavior: "smooth",
          });
        });

        newNext.addEventListener("click", () => {
          newMobileListWrapper.scrollTo({
            left: newMobileListWrapper.scrollLeft + 200,
            behavior: "smooth",
          });
        });

        Clerk("click", "*[data-clerk-product-id]");
      });

      Clerk("click", "*[data-clerk-product-id]");
    },
    function (error) {
      desktopUpsellDrawer.hidden = true;
    }
  );
};

if (clerkCartUpsell) {
  initCartUpsell();

  document.addEventListener("cart-drawer-rendered", () => {
    initCartUpsell();
  });
}
